export default {
  // wz: 'http://119.3.91.168',
  // picUrl: 'https://10000wz.obs.cn-east-2.myhuaweicloud.com',
  // picUrl2: 'http://119.3.91.168'
  wz: 'https://www.api.10000wz.com',
  picUrl: 'https://10000wz.obs.cn-east-2.myhuaweicloud.com',
  picUrl2: 'https://www.api.10000wz.com'
}



// WEBPACK FOOTER //
// ./src/axios/url.js